<template>
  <div>
    <div v-if="showCarousel">
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        fade
        controls
        indicators
        background="#ababab"
        style="color: #fff; text-shadow: 1px 1px 2px #fff;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide class="booking-img">
          <template #img>
            <img
              class="d-block img-cover"
              :src="imageFacadePath"
              alt="image slot"
              @click="openViewer(imageFacadePath)"
            >
          </template>
        </b-carousel-slide>
        <b-carousel-slide class="booking-img">
          <template #img>
            <img
              class="d-block img-cover"
              :src="imageInsidePath"
              alt="image slot"
              @click="openViewer(imageInsidePath)"
            >
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div>
    <div
      v-else
      :class="imgClass"
    >
      <img
        :src="imageInsidePath"
        :class="imgClass"
        @click="openViewer(imageInsidePath)"
      >
    </div>

    <ImageViewer
      :id="'booking-image-viewer'"
      :image-url="viewerImage"
    />
  </div>
</template>

<script>
import ImageViewer from '@/components/ImageViewer.vue';

export default {
  name: 'StoreImages',
  components: { ImageViewer },
  props: {
    store: {
      type: Object,
      required: true,
    },
    bookingConfirm: {
      type: Boolean,
      default: false,
    },
    imgClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      slide: 0,
      sliding: null,
      viewerImage: null,
    };
  },

  computed: {
    showCarousel() {
      if (this.bookingConfirm) {
        if (this.store.image_facade == null || !this.store.image_inside == null) {
          return false;
        }
        return true;
      }
      return false;
    },

    imageInsidePath() {
      const imageInsidePath = `${process.env.VUE_APP_BACKEND_SERVER}/storage/${this.store.image_inside}`;
      return encodeURI(imageInsidePath).replace(' ', '%20');
    },

    imageFacadePath() {
      const imageFacadePath = `${process.env.VUE_APP_BACKEND_SERVER}/storage/${this.store.image_facade}`;
      return encodeURI(imageFacadePath).replace(' ', '%20');
    },
  },

  methods: {

    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    openViewer(image) {
      this.viewerImage = image;
      this.$bvModal.show('booking-image-viewer');
    },

  },
};
</script>

<style scoped>

</style>
